import styled, { css } from "styled-components";
import AntForm, { FormProps } from "antd/es/form";
import { hexToRGB } from "@shared/utils/misc";
import { newLookFieldStates } from "common/Inputs/styles";

const Form = ({ style, ...props }: FormProps) => {
  return <StyledForm {...props} style={style} />;
};

Form.Item = AntForm.Item;
export default Form;

const StyledForm = styled(AntForm)<FormProps>`
  &&& {
    .ant-form-item-label > label {
      color: ${(p) => p.theme.colors.primaryText};
    }
    .ant-input,
    .ant-input-affix-wrapper {
      background: ${(p) => p.theme.colors.cardBgColor};
    }
    .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
      border-color: ${(p) => p.theme.colors.primaryBlue};
    }
    .ant-input-affix-wrapper-focused {
      border-color: ${(p) => p.theme.colors.primaryBlue};
    }
    .ant-input {
      color: ${(p) => p.theme.colors.textColor};
    }
    .ant-input-affix-wrapper {
      border-color: ${(p) => p.theme.colors.mediumBorderGrey};
    }
    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 30px ${(p) =>
        p.theme.colors.cardBgColor} inset !important;
      -webkit-text-fill-color: ${(p) => p.theme.colors.textColor} !important;
    }
    
    .ant-form-item-has-error .ant-input {
      box-shadow: 0 0 0 2px ${(p) =>
        hexToRGB(p.theme.colors.red, 0.2)}!important;
    }
    .ant-form-item-has-error :not(.ant-input-disabled):not(.ant-input-borderless).ant-input, 
    .ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper{
      background: ${(p) => p.theme.colors.cardBgColor};
    }
    .ant-form-item-has-error .ant-input-affix-wrapper .ant-input {
      box-shadow: none !important;
    }
    .ant-form-item-explain-error {
      color: ${(p) => p.theme.colors.red};
    }
    .ant-input[disabled] {
      background: ${(p) => p.theme.colors.disabledInput};!important;
      color: ${(p) => p.theme.colors.disabledText};!important;
      border-color: ${(p) => p.theme.colors.mediumBorderGrey};!important
    }
    .ant-form-item textarea.ant-input {
      border-color: ${(p) => p.theme.colors.mediumBorderGrey};!important
    color: ${(p) => p.theme.colors.textColor};
    }
    textarea.ant-input:hover, textarea.ant-input:focus{
      border-color: ${(p) => p.theme.colors.primaryBlue};
    }
    .ant-input-textarea-show-count::after {
      color: ${(p) => p.theme.colors.textColor};
    }
    ${(p) => p.theme.isNewLook && newLookFormFields}
  }
`;

// New look: fields keep the platform field states (soft border, darker on
// hover, blue ring only on focus); errors are a red border, ringed on focus.
const newLookFormFields = css`
  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-borderless),
  .ant-input:not(.ant-input-borderless):not(
      .ant-input-affix-wrapper .ant-input
    ),
  .ant-form-item textarea.ant-input {
    ${newLookFieldStates};
  }
  .ant-input-affix-wrapper > .ant-input:focus {
    box-shadow: none;
  }
  .ant-form-item-has-error {
    .ant-input:not(.ant-input-affix-wrapper .ant-input),
    .ant-input-affix-wrapper {
      border-color: ${(p) => p.theme.colors.red};
      box-shadow: none !important;
      &:focus,
      &:focus-within {
        box-shadow: 0 0 0 3px ${(p) => hexToRGB(p.theme.colors.red, 0.14)} !important;
      }
    }
  }
  .ant-input[disabled],
  .ant-input-affix-wrapper-disabled {
    background: ${(p) => p.theme.colors.cardLightBgColor};
    border-color: ${(p) => p.theme.colors.lightBorderGrey};
  }
`;
